import { useMutation, useQueryClient } from "react-query";
import axios from "../axios";
import { EditUserResponse } from "../../constants/types";

const updateUser = async (formData: FormData) => {
    const response = await axios.post<EditUserResponse>("/api/users", formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
};

export default function useUpdateUser() {
    const queryClient = useQueryClient();

    return useMutation((formData: FormData) => updateUser(formData), {
        onSuccess: () => {
            queryClient.invalidateQueries(["user"]);
        },
    });
}
